import { useEffect } from "react";
import { useWindowControlsOverlay } from "../hooks/useWindowControlsOverlay";

/** Sets data-wco-visible and CSS vars for WCO; no UI (single header = GlobalHeader) */
export const WindowControlsOverlaySetup: React.FC = () => {
  const { isVisible: inOverlay, titlebarAreaRect } = useWindowControlsOverlay();

  useEffect(() => {
    if (inOverlay) {
      document.documentElement.dataset.wcoVisible = "true";
    } else {
      delete document.documentElement.dataset.wcoVisible;
    }
  }, [inOverlay]);

  useEffect(() => {
    if (!titlebarAreaRect) {
      document.documentElement.style.removeProperty("--wco-titlebar-x");
      document.documentElement.style.removeProperty("--wco-titlebar-y");
      document.documentElement.style.removeProperty("--wco-titlebar-width");
      document.documentElement.style.removeProperty("--wco-titlebar-height");
      return;
    }
    document.documentElement.style.setProperty("--wco-titlebar-x", `${titlebarAreaRect.x}px`);
    document.documentElement.style.setProperty("--wco-titlebar-y", `${titlebarAreaRect.y}px`);
    document.documentElement.style.setProperty("--wco-titlebar-width", `${titlebarAreaRect.width}px`);
    document.documentElement.style.setProperty("--wco-titlebar-height", `${titlebarAreaRect.height}px`);
  }, [titlebarAreaRect]);

  return null;
};
